// Generated with util/create-component.js
import { MeshOptions, GeometryFilter } from "../hooks"

export enum GetModelActions {
  selection = 'selection',
  subscribe = 'subscribe',
  preview = 'preview'
}

export interface GetGeometryProps {
  defaultKey: string
  setParentState?: (data: any) => void
  optionsConfig?: { [index in GetModelActions] : { show?: boolean, selected?: boolean }}
  buttonLabel?: string
  useIcon?: boolean
  meshOptions?: MeshOptions
  geometryFilter?: GeometryFilter
  fullWidth?: boolean
}
